import { PopupConfig } from "@/store/types";
import { cloneConfig } from "./config";
export const est = {
  title: "Est",
  atom: "estHct",
  class: "spaceRight",
  popupName: "Hematocrit"
};

export function awor() {
  const clonedConfig = cloneConfig();
  clonedConfig.body.patientDetailBodyComponent = "PatientDetailOR";
  clonedConfig.body.patientDetialLabels.los = false;
  clonedConfig.body.defaultPhoneLabel = "OR Phone";

  clonedConfig.global.showPagingIcon = false;

  clonedConfig.parts.brainText.visible = true;
  clonedConfig.parts.brain.atomOverride = "mac";

  const pagingFields = [
    { key: "pageWho", text: "Who" },
    { key: "pageDelay", text: "Delay" },
    {
      key: "noBypass",
      text: "Bypass Rules",
      filter: (input: string | number) => {
        switch (input) {
          case 1:
          case "1":
            return "Disabled <b>DURING</b> bypass";
          case 2:
          case "2":
            return "Disabled for <b>ENTIRE</b> bypass case";
          default:
            return "";
        }
      }
    }
  ];

  clonedConfig.help.paging.fields = clonedConfig.help.paging.fields.concat(
    pagingFields
  );

  clonedConfig.popups.Creatinine.risks = true;
  clonedConfig.popups.Brain.display.showOrRisks = true;
  clonedConfig.popups.Brain.display.showMacText = true;

  clonedConfig.labConfigs.push({
    title: "Lactate",
    atom: "lactate",
    popupName: "Lactate"
  });

  const defaultPopupConfig: PopupConfig = {
    graphRanges: [
      { text: "1 hour", hours: 1 },
      { text: "2 hours", hours: 2 },
      { text: "4 hours", hours: 4 },
      { text: "8 hours", hours: 8 },
      { text: "All", hours: 0 }
    ],
    graphStartingIndex: 0
  };
  clonedConfig.defaultPopupDescription = defaultPopupConfig;

  clonedConfig.popups.Lactate = {
    component: "GenericRiskAndGraph",
    popupConfig: {
      title: "Lactate",
      graphStartingIndex: 2,
      graphs: [
        {
          title: "Lactate",
          source: "Lactate"
        },
        {
          title: "Bicarbonate",
          source: "Bicarb"
        }
      ]
    }
  };

  clonedConfig.labConfigs[2].class = "spaceLeft";

  clonedConfig.labConfigs.splice(3, 0, est);
  clonedConfig.body.buttons.PreOpPainScore.visible = true;
  clonedConfig.body.buttons.Handoff.visible = true;
  clonedConfig.census.LegendDescription = [
    {
      icon: "alertPhys1.png",
      label: "One or more active physiologic alert(s)"
    },
    {
      icon: "alertPhys2.png",
      label: "One or more severe active physiologic alert(s)"
    },
    {
      icon: "alertPhys3.gif",
      label: "Paging for an active alert"
    },
    { icon: "alertBilling.png", label: "Billing alert" },
    { icon: "alertETT1.png", label: "Intubation risk factors" },
    { icon: "alertETT2.png", label: "History of difficult intubation" },
    { icon: "alertBypass.png", label: "On bypass" },
    { icon: "alertASA4.png", label: "ASA 4" },
    { icon: "alertASA5.png", label: "ASA 5" },
    { icon: "alertIsolation.png", label: "Contact or Isolation Precaution" },
    {
      icon: "alertIsolation2.png",
      label: "High Risk Contact or Isolation Precaution"
    },
    { icon: "note3.png", label: "Care coordination note is present" },
    { icon: "note1.png", label: "Misc note present" },
    { icon: "COVID-19_1.png", label: "COVID-19 test missing or inactive." },
    { icon: "COVID-19_2.png", label: "COVID-19 test result negative." },
    { icon: "COVID-19_3.png", label: "COVID-19 test result pending." },
    {
      icon: "COVID-19_4.png",
      label: "COVID-19 test inactive, previously positive."
    },
    { icon: "COVID-19_5.png", label: "COVID-19 test positive." }
  ];

  clonedConfig.census.legend = [
    {
      label: "Text Alert",
      paths: ["alertPhys1", "alertPhys2"]
    },
    { label: "Billing", paths: ["alertBilling"] },
    {
      label: "Difficult Airway",
      paths: ["alertETT1", "alertETT2"]
    },
    { label: "Bypass", paths: ["alertBypass"] },
    {
      label: "ASA Status",
      paths: ["alertASA4", "alertASA5"]
    },
    {
      label: "Precaution",
      paths: ["alertIsolation", "alertIsolation2"]
    },
    {
      label: "COVID-19 Status",
      paths: [
        "COVID-19_1",
        "COVID-19_2",
        "COVID-19_3",
        "COVID-19_4",
        "COVID-19_5"
      ]
    },
    {
      label: "Care Note",
      paths: ["note3", "note1"]
    }
  ];

  clonedConfig.census.legendTower = clonedConfig.census.legend.slice();

  clonedConfig.census.legendTower.push({
    label: "Out of Range",
    paths: ["alertOrgan1", "alertOrgan2"]
  });

  clonedConfig.census.legendTower.push({
    label: "Do Not Contact",
    paths: ["alertDNC"]
  });

  clonedConfig.census.legendTower.push({
    label: "Case Review",
    paths: [
      "alertReview0",
      "alertReview1",
      "alertReview3",
      "alertReview4",
      "alertReview5",
      "alertReview6"
    ]
  });

  clonedConfig.census.legend.forEach((item: any) => {
    item.paths = item.paths.map((path: string) => {
      return `${path}.png`;
    });
  });

  return clonedConfig;
}
